

























































import Vue from 'vue';
import DefaultWorkflowQueue from './DefaultWorkflowQueue.vue';
import { ColumnsModel } from '@/types/models/table/ColumnsModel';
import { WorkflowJobService } from '@/services/WorkflowJobService';
import { WorkflowJobsEmailModel } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreGroupedTable from '@/components/shared/Table/MStoreGroupedTable.vue';
import { Fullscreen } from '@/utils';

export default Vue.extend({
  name: 'BulkEmailWorkflowQueue',
  mixins: [DefaultWorkflowQueue],
  data() {
    return {
      showModal: false,
      postIsLoading: false,
      detailFields: ['jobid', 'documenttype'],
      isFullscreen: false
    };
  },
  methods: {
    getSendButtonText(jobs: any) {
      const numberOfJobs = jobs.length;
      return `Send ${numberOfJobs} ${numberOfJobs > 1 ? 'Documents' : 'Document'}`;
    },
    async sendDocumentsAsync(this: any, event: any, jobs: any) {
      this.$bvModal
        .msgBoxConfirm(`You are about to ${this.getSendButtonText(jobs).toLowerCase()} to "${jobs[0].emailaddress}".`, {
          id: 'bulkEmailConfirmationModal',
          title: 'Are you sure?',
          cancelVariant: 'danger',
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        })
        .then(async (result: boolean) => {
          if (result) {
            this.postIsLoading = true;
            try {
              await WorkflowJobService.emailWorkflowJobsAsync(this.workflowQueueDataModel.queueId, {
                jobIds: jobs.map((x: any) => x.jobid)
              } as WorkflowJobsEmailModel);
            } catch (exception) {
              this.$log(exception);
            } finally {
              this.postIsLoading = false;
              this.getWorkflowQueue();
            }
          }
        });
    },
    handleOnFullscreenChange(this: any) {
      this.isFullscreen = Fullscreen.isFullscreen();
    }
  },
  components: {
    MStoreGroupedTable,
    LoadingSpinner
  },
  created() {
    Fullscreen.registerFullscreenChange(this.handleOnFullscreenChange);
  },
  beforeDestroy() {
    Fullscreen.removeFullscreenChange(this.handleOnFullscreenChange);
  }
});
